import Slider from '../Slider';

const EVENTS = {
  touch: {
    START: 'touchstart',
    MOVE: 'touchmove',
    END: 'touchend'
  }
};

export default class Touch {
  private _slider: Slider;
  private startX: number;
  private startY: number;
  private endX: number;
  private endY: number;
  private isEnabled: boolean;

  constructor(slider: Slider) {
    this._slider = slider;

    this.startX = 0;
    this.startY = 0;
    this.endX = 0;
    this.endY = 0;

    this.isEnabled = false;

    document.addEventListener(EVENTS.touch.START, this.onStart.bind(this) as EventListener, false);
    document.addEventListener(EVENTS.touch.MOVE, this.onMove.bind(this) as EventListener, false);
    document.addEventListener(EVENTS.touch.END, this.onStop.bind(this) as EventListener, false);
  }

  onStart(event: TouchEvent) {
    const info = Touch.normalizeEventInfo(event);

    if (event.touches.length === 1) {
      this.startX = info.x;
      this.startY = info.y;
      this.endX = info.x;
      this.endY = info.y;
    }
  }

  onMove(event: TouchEvent) {
    const info = Touch.normalizeEventInfo(event);

    this.endX = info.x;
    this.endY = info.y;
  }

  onStop() {
    const diffX = this.startX - this.endX;
    const diffY = this.startY - this.endY;
    if (Math.abs(diffX) > Math.abs(diffY)) {
      // 滑动偏移量
      const slideOffset = 50;
      let direction = '';
      if (diffX < -slideOffset) {
        direction = 'prev';
      } else if (diffX > slideOffset) {
        direction = 'next';
      }
      const event = new CustomEvent('slide', { detail: { direction } });
      this._slider.getRoot().dispatchEvent(event);
    }
  }

  static normalizeEventInfo(event: TouchEvent) {
    let touchEvent = { pageX: 0, pageY: 0 };
    touchEvent = event.changedTouches[0];
    const x = touchEvent.pageX;
    const y = touchEvent.pageY;
    return { x, y };
  }
}
